import { Stack } from 'expo-router';

export default function GymJoinLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
